"use client";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/AccordionsPanel/TabDescription.tsx
import classNames from "classnames";
import { m } from "framer-motion";
import { jsx, jsxs } from "react/jsx-runtime";
var TabDescriptionVariants = {
  open: {
    height: "auto"
  },
  close: {
    height: 0,
    overflow: "hidden"
  }
};
function TabDescription({
  title,
  items,
  isOpen,
  setIsOpen
}) {
  return /* @__PURE__ */ jsxs("li", { children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        onClick: setIsOpen,
        className: "flex justify-between py-16 w-full bg-transparent border-0 border-b border-display-300 border-solid",
        children: [
          /* @__PURE__ */ jsx(
            "p",
            {
              className: "font-semibold text-lg leading-3",
              dangerouslySetInnerHTML: {
                __html: title
              }
            }
          ),
          /* @__PURE__ */ jsx(
            Icon_default,
            {
              name: "chevronDown",
              className: classNames(
                "w-24 h-24 fill-current transition-all transform-gpu",
                {
                  "rotate-180": isOpen
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      m.div,
      {
        variants: TabDescriptionVariants,
        style: {
          height: isOpen ? "auto" : 0,
          overflow: "hidden"
        },
        children: items == null ? void 0 : items.map(({ item }) => {
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: "flex flex-col md:flex-row md:gap-28 justify-between md:items-center py-16 border-b border-display-300",
              children: [
                /* @__PURE__ */ jsxs("div", { children: [
                  /* @__PURE__ */ jsx(
                    "p",
                    {
                      className: "text-lg leading-3",
                      dangerouslySetInnerHTML: {
                        __html: item.label
                      }
                    }
                  ),
                  item.label === "Boletos n\xE3o pagos" && /* @__PURE__ */ jsx("p", { className: "pt-8 text-display-600 text-sm", children: "Poder\xE1 haver cobran\xE7a caso o n\xFAmero de boletos efetivamente pagos seja inferior a 40% do volume total de boletos no m\xEAs, confira as condi\xE7\xF5es nos termos e uso da conta" })
                ] }),
                /* @__PURE__ */ jsx(
                  "p",
                  {
                    className: "mt-4 md:mt-0 font-bold text-stone-500 text-lg leading-3",
                    dangerouslySetInnerHTML: {
                      __html: item.value
                    }
                  }
                )
              ]
            },
            item.label
          );
        })
      }
    )
  ] });
}

export {
  TabDescription
};
